import { useSelector } from 'react-redux';
import { useAuth } from './useAuth';
import { selectPermissions } from '@store/slices/authSlice';

export const usePermissions = () => {
  const { user } = useAuth();
  const permissions = useSelector(selectPermissions);
  
  

  const hasPermission = (permission) => {
    if (!user || user.role !== 'admin') return false;
    if (user.isSuperAdmin) return true;
    
    // Check if permissions array contains objects with name property or plain strings
    return permissions.some(p => 
      typeof p === 'string' ? p === permission : p.name === permission
    );
  };

  const hasAnyPermission = (permissionList) => {
    if (!user || user.role !== 'admin') return false;
    if (user.isSuperAdmin) return true;
    return permissionList.some(permission => 
      permissions.some(p => 
        typeof p === 'string' ? p === permission : p.name === permission
      )
    );
  };

  const hasAllPermissions = (permissionList) => {
    if (!user || user.role !== 'admin') return false;
    if (user.isSuperAdmin) return true;
    return permissionList.every(permission => 
      permissions.some(p => 
        typeof p === 'string' ? p === permission : p.name === permission
      )
    );
  };

  return {
    hasPermission,
    hasAnyPermission,
    hasAllPermissions,
    permissions,
    loading: false,
    isSuperAdmin: user?.isSuperAdmin || false,
  };
};
